import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import AppShell from "@/components/AppShell";
import { initSync } from "@/lib/sync";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import HeatPumpDetail from "@/pages/HeatPumpDetail";
import Reports from "@/pages/Reports";
import ReportForm from "@/pages/ReportForm";
import ReportView from "@/pages/ReportView";
import SharedReport from "@/pages/SharedReport";
import ResetPassword from "@/pages/ResetPassword";
import Team from "@/pages/Team";
import Schedule from "@/pages/Schedule";
import NewReportChooser from "@/pages/NewReportChooser";
import ImportData from "@/pages/ImportData";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

const AdminShell = ({ children }) => (
  <AdminRoute>
    <AppShell>{children}</AppShell>
  </AdminRoute>
);

function App() {
  useEffect(() => {
    document.title = "Sterio Renewables Service Portal";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Sterio Renewables Service Portal — heat pump servicing & reports");
    const favSvg =
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Crect width='32' height='32' rx='7' fill='%231B6B4C'/%3E%3Ctext x='16' y='22' font-family='Arial,sans-serif' font-size='16' font-weight='700' fill='white' text-anchor='middle'%3ESR%3C/text%3E%3C/svg%3E";
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = favSvg;

    const cleanup = initSync();
    return cleanup;
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/shared/:shareId" element={<SharedReport />} />

            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/customers" element={<Shell><Customers /></Shell>} />
            <Route path="/customers/:id" element={<Shell><CustomerDetail /></Shell>} />
            <Route path="/heatpump/:id" element={<Shell><HeatPumpDetail /></Shell>} />
            <Route path="/reports" element={<Shell><Reports /></Shell>} />
            <Route path="/report/new" element={<Shell><ReportForm /></Shell>} />
            <Route path="/report/choose" element={<Shell><NewReportChooser /></Shell>} />
            <Route path="/report/:id/edit" element={<Shell><ReportForm /></Shell>} />
            <Route path="/report/:id/view" element={<Shell><ReportView /></Shell>} />
            <Route path="/team" element={<AdminShell><Team /></AdminShell>} />
            <Route path="/schedule" element={<AdminShell><Schedule /></AdminShell>} />
            <Route path="/import" element={<AdminShell><ImportData /></AdminShell>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
